import { Icon, VStack } from "@/shared/ui/primitives";

export interface CommonHeaderProps {
	title: string;
	description: string;
	onTap?: () => void;
}

export const CommonHeader = (p: CommonHeaderProps) => {
	return (
		<VStack className="w-full gap-[10px] p-[4px] text-ct-regular items-start">
			<button onClick={p.onTap} type="button">
				<Icon name="Back" width={20} height={20} />
			</button>
			<VStack className="w-full gap-[6px]">
				<span className="w-full text-ct-strong text-xl font-semibold">{p.title}</span>
				<span className="w-full text-sm font-normal">{p.description}</span>
			</VStack>
		</VStack>
	);
};
